<ng-container *ngIf="currentPageControl
                        && currentPageControl.value !== null
                        && pagesLength !== undefined
                        && pagesLength > 1"
>
    <app-button size="normal"
                theme="dark"
                layout="icon-only"
                icon="arrow-left"
                [disabled]="currentPageControl.value <= 0"
                (clicked)="prev()"
    ></app-button>

    <app-select [control]="currentPageControl" size="large">
        <option *ngFor="let page of selectablePages; let index = index"
                [value]="index"
                [selected]="index === currentPageControl.value"
        >
            {{ page }} {{'common.of' | translate}} {{ pagesLength }}
        </option>
    </app-select>

    <app-button size="normal"
                theme="dark"
                layout="icon-only"
                icon="arrow-right"
                [disabled]="currentPageControl.value >= pagesLength - 1"
                (clicked)="next()"
    ></app-button>
</ng-container>
